// ---- FlexLayout base model JSON (created once) ----
import type { IJsonModel } from 'flexlayout-react';

export const mainTabsetId = 'main_tabset';
export const mainTabId = 'main';

export const stepEditTabId = 'stepEdit';

export const dataTabId = 'dataViewer';

export const chatTabId = 'chatViewer';

export const baseJson: IJsonModel = {
  global: { tabSetEnableTabStrip: false, tabMinWidth: 200 },
  borders: [],
  layout: {
    type: 'row',
    id: 'row',
    weight: 100,
    children: [
      {
        type: 'tabset',
        id: mainTabsetId,
        children: [{ type: 'tab', id: mainTabId, component: mainTabId }],
      },
    ],
  },
};
